/* eslint-disable prettier/prettier */
import { ProductFragment } from '@core-mkt/shared/craft/product-entry-fragment';
import * as gql from 'fake-tag';

export const TopSectionFragment = {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  TopSection: gql`
    fragment TopSectionQuery on topSectionWysiwyg_Entry {
      backgroundImage {
        url
        ... on images_Asset {
          altText
        }
      }
      bottomRightContent {
        ... on bottomRightContentBlock_Entry {
          sealIcon {
            url
            ... on images_Asset {
              altText
            }
          }
          sealIconText {
            html
          }
        }
      }
      categoryWidgets {
        ... on categoryWidgets_Category {
          categoryContent
          categoryImage {
            url
            ... on images_Asset {
              altText
            }
          }
          categoryTitle
        }
      }
      contentAlignment
      ctaLabel
      ctaNewTab
      ctaNofollow
      ctaType
      ctaLink
      ctaTag
      eyebrow
      featuredContent {
        ... on featuredContentBlock_Entry {
          featuredContentIcon {
            url
            ... on images_Asset {
              altText
            }
          }
          featuredContentText {
            html
          }
        }
      }
      hideGuaranteeLink
      highlightedTextModal1: highlightedTextModal14 {
        ... on highlightedTextModal14Block_Entry {
          modalContent {
            html
          }
        }
      }
      highlightedTextModal2: highlightedTextModal24 {
        ... on highlightedTextModal24Block_Entry {
          modalContent {
            html
          }
        }
      }
      lineBreak_buttons
      lineBreak_mainContent
      lineBreak_modals
      lineBreak_rightContent
      lineBreak_styles
      modalContent
      courseOverviewPopup
      product {
        ...ProductEntry
      }
      productSeal {
        url
        ... on images_Asset {
          altText
        }
      }
      rightContent
      sectionContent
      sectionTitle
      showOfferTimer
      showPricing
      showTrustpilotStars
      starCaption
      starRating
      styles
      topSectionContentSplit
      slideAutoplay
      topSectionCarousel {
        ... on topSectionCarouselBlock_Entry {
          topSectionCarouselImage {
            url
            ... on images_Asset {
              altText
            }
          }
          topSectionCarouselText {
            html
          }
        }
      }
      typeHandle
      videoButton {
        ... on videoButtonBlock_Entry {
          ctaLabel
          ctaType
          wistiaId
          buttontype
          ctaOtherlink
        }
      }
      widgetTip
    }
    ${ProductFragment.product}
  `,
};
